import { atomWithStore } from "jotai-redux";
import { atomWithObservable } from "jotai/utils";
import store, { showSavingsIcon$ } from "../store";

export const CanEscapeRefStore = atomWithObservable<boolean>(() => showSavingsIcon$);
export const RootStore = atomWithStore<{ updates: RootStoreModule.State }>(store);
